import { Component } from '@angular/core';

@Component({
  selector: 'followup-template',
  templateUrl: './followup-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss', '../../form-steps.scss']
})
export class FollowupTemplateComponent {
  opened = false
}
